<template>
  <div>
    <div class="bg-no-repeat bg-cover h-auto mb-10">
      <div class="w-full relative">
        <img src="@/assets/images/home/产品首页图片.png" />
        <div
          class="absolute top-0 bottom-0 grid grid-cols-6 gap-4 h-full flex flex-wrap content-center text-white text-3xl"
        >
          <div class="col-start-2 col-span-4">行业应用</div>
        </div>
      </div>
    </div>
    <div v-for="(v, i) in items" :key="i">
      <div
        class="mx-auto mb-3 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg"
      >
        <div class="flex items-center">
          <div class="flex-no-grow px-4 my-4 border-r border-gray-500">
            <svg
              class="text-gray-500 w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
              />
            </svg>
          </div>
          <div class="flex-grow px-4 my-4 ">{{ v.title }}</div>
          <div class="flex-no-grow px-4 mt-4 mb-2">
            <svg
              class="text-gray-400 w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
        <div
          class="flex items-center hover:bg-gray-100"
          @click="handleClick(v)"
        >
          <div class="flex-no-grow px-1 my-3 border-none border-gray-500">
            <svg
              class="text-gray-500 w-3 h-3"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            ></svg>
          </div>
          <div class="flex-grow px-4 mb-3  flex items-center">
            <div class="flex-no-grow pr-2">
              <svg
                class="text-gray-500 w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div class="flex-grow text-xs">{{ v.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "hello",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      items: [
        {
          title: "组角胶应用",
          videoUrl: `videos/001-组角胶应用.mp4`,
        },
        {
          title: "美缝收边应用",
          videoUrl: `videos/002-美缝收边应用.mp4`,
        },
        {
          title: "固体表面应用",
          videoUrl: `videos/003-固体表面应用.mp4`,
        },
        {
          title: "植筋胶应用",
          videoUrl: `videos/004-植筋胶应用.mp4`,
        },
      ],
    };
  },
  created() {},

  methods: {
    handleClick(video) {
      this.$router.push({
        path: "/media/" + video.title,
        query: {
          videoUrl: `http://8.130.22.203:10020/${video.videoUrl}`,
        },
      });
    },
  },
};
</script>
<style scoped></style>
